export enum ServiceStatuses {
	YES = "YES",
	NO = "NO",
	YES_MAJOR = "YES_MAJOR",
	YES_MINOR = "YES_MINOR"
}
